import * as orderRepo from "../repos/graphql/order";
import { orderMethods, orderTypeIds } from '../constants/order';
import { shippingMethods } from '../constants/store';
import { store } from '../../redux/store';
import * as elementsActions from '../../redux/actions/elements';
import { openCartCreateFailModal } from './modals';
import { getErrorMessages, getErrorReasons } from './common';
import errorCodes from '../constants/errorCodes';
import { clearCart } from './orders';
import * as productConstants from '../constants/product';

export const handleCreateCart = async (selectedStore, userAddress, userOrderMethod, setUserCartId, setUserAddress) => {
  let data = {};
  if (userOrderMethod === orderMethods.pickup) {
    const addressComponents = {
      address1: selectedStore.mailingAddress,
      city: selectedStore.city,
      state: selectedStore.state,
      postcode: selectedStore.zip,
      lat: selectedStore.lat,
      lng: selectedStore.lng,
      countryId: parseInt(selectedStore.countryId, 10)
    };
    setUserAddress(addressComponents);
    data = {
      storeId: selectedStore.id,
      orderTypeId: orderTypeIds.pickup,
      shippingMethod: shippingMethods.pickup,
      address: addressComponents
    };
  } else {
    const addressComponents = {
      address1: userAddress.address1,
      city: userAddress.city,
      state: userAddress.state,
      postcode: userAddress.postcode,
      lat: userAddress.lat,
      lng: userAddress.lng,
      dormId: userAddress.dormId,
      countryId: userAddress.countryId,
      address2: userAddress.address2
    };
    data = {
      storeId: selectedStore.id,
      orderTypeId: orderTypeIds.delivery,
      shippingMethod: shippingMethods.delivery,
      address: addressComponents
    };
  }
  try {
    const response = await orderRepo.createCart(data);
    const { createCart } = response.data;
    setUserCartId(createCart.code);
    return true;
  } catch (reason) {
    const message = getErrorMessages(reason, 0) || reason?.message;
    const reasonType = getErrorReasons(reason, 0);
    if (reasonType === errorCodes.CART_CREATE_ERROR) {
      store.dispatch(
        elementsActions.setModalObject(openCartCreateFailModal(message, clearCart))
      );
    }
    return false;
  }
};

const CART_ERROR_MESSAGES_BY_REASON = {
  [errorCodes.PICKUP_PRODUCT_UNAVAILABLE_REASON]:
    productConstants.PICKUP_UNAVAILABLE_PRODUCT_MESSAGE,
  [errorCodes.DELIVERY_PRODUCT_UNAVAILABLE_REASON]:
    productConstants.DELIVERY_UNAVAILABLE_PRODUCT_MESSAGE,
  [errorCodes.ADD_PRODUCT_TO_ORDER_STORE_COMING_SOON_ERROR]:
    productConstants.STORE_COMING_SOON_MESSAGE
};

export const getCartErrorMessage = (reason) => {
  const em = 'Something went wrong! Please try again.';
  const graphQLErrors = reason?.graphQLErrors;
  if (!graphQLErrors?.length) {
    return em;
  }
  const isReason = getErrorReasons(reason, 0);
  const mappedMessage = Object.prototype.hasOwnProperty.call(
    CART_ERROR_MESSAGES_BY_REASON,
    isReason
  )
    ? CART_ERROR_MESSAGES_BY_REASON[isReason]
    : null;
  return mappedMessage || graphQLErrors[0].message || em;
};
